export default "__VITE_ASSET__CGKhKPHr__"